import dayjs from "dayjs";

export const at = (object, path) => path.split(".").reduce((value, key) => value?.[key], object);

function converted(value, kind) {
  if (value === undefined || value === null || value === "") return null;
  if (kind === "date") {
    const date = dayjs(value);
    if (!date.isValid() || (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)
        && date.format("YYYY-MM-DD") !== value)) throw new Error("Revise la fecha informada.");
    return date.format("YYYY-MM-DD");
  }
  if (kind === "number" || kind === "id") {
    const numeric = typeof value === "boolean" || (typeof value === "string" && !value.trim()) ? NaN : Number(value);
    if (!Number.isFinite(numeric) || (kind === "id" && (!Number.isSafeInteger(numeric) || numeric < 1))) {
      throw new Error("Revise los valores numéricos informados.");
    }
    return numeric;
  }
  if (kind === "idList") {
    const values = Array.isArray(value) ? value : [value];
    return values.filter((item) => item !== "" && item !== null).map((item) => converted(item, "id"));
  }
  if (kind === "diagnoses") {
    return (value || []).map(({ diagnostico, ...item }) => {
      const texto = (diagnostico || "").trim();
      return texto ? { ...item, texto } : Object.prototype.hasOwnProperty.call(item, "texto") ? { ...item, texto: null } : item;
    })
      .filter((item) => item.texto || item.conceptoId);
  }
  if (kind === "motives") {
    return (value || []).map((item) => (item.motivoConsulta || "").trim()).filter(Boolean);
  }
  if (kind === "treatments") {
    return (value || []).map((item) => ({ nombre: (typeof item === "string" ? item : item?.nombre || "").trim() }))
      .filter((item) => item.nombre);
  }
  if (typeof value === "string") return value.trim() || null;
  return value;
}

function put(target, path, value) {
  const keys = path.split(".");
  let node = target;
  for (let i = 0; i < keys.length - 1; i += 1) {
    if (!node[keys[i]] || typeof node[keys[i]] !== "object") node[keys[i]] = {};
    node = node[keys[i]];
  }
  node[keys[keys.length - 1]] = value;
}

// Each mapper is [UI key, API path, type]. A PUT starts from GET and replaces only changed controls.
export function serializeMappedForm(ui, mapping, original = {}, baseline = {}) {
  const result = JSON.parse(JSON.stringify(original || {}));
  for (const [uiKey, apiPath, kind] of mapping) {
    const current = converted(ui[uiKey], kind);
    const previous = converted(baseline[uiKey], kind);
    if (JSON.stringify(current) === JSON.stringify(previous)) continue;
    if ((current === null || (Array.isArray(current) && current.length === 0)) && previous === null) continue;
    if (kind === "treatments" && Array.isArray(current)) {
      const stored = at(original, apiPath);
      const available = Array.isArray(stored) ? [...stored] : [];
      const enriched = current.map((item) => {
        const index = available.findIndex((entry) => entry.nombre === item.nombre);
        return index < 0 ? item : available.splice(index, 1)[0];
      });
      put(result, apiPath, [...enriched, ...available.filter((entry) => !entry.nombre)]);
    } else put(result, apiPath, current);
  }
  return result;
}

export function hydrateMappedForm(datos, mapping) {
  const ui = {};
  for (const [uiKey, apiPath, kind] of mapping) {
    const value = at(datos, apiPath);
    if (kind === "date") ui[uiKey] = value ? dayjs(value) : null;
    else if (["id", "number"].includes(kind)) ui[uiKey] = value ?? "";
    else if (kind === "idList") ui[uiKey] = Array.isArray(value) ? value : [];
    else if (kind === "motives") ui[uiKey] = Array.isArray(value) ? value.map((motivoConsulta) => ({ motivoConsulta })) : [{ motivoConsulta: "" }];
    else if (kind === "diagnoses") ui[uiKey] = Array.isArray(value) ? value.map((item) => ({ ...item, diagnostico: item.texto || "" })) : [{ diagnostico: "" }];
    else if (kind === "treatments") ui[uiKey] = Array.isArray(value) ? value.map(({ nombre }) => nombre).filter(Boolean) : [];
    else ui[uiKey] = value ?? "";
  }
  return ui;
}

